import React, { useState } from "react";

const Quotation = () => {
  const [bedrooms, setBedrooms] = useState("");
  const [extraItems, setExtraItems] = useState("");
  const [tvWidth, setTvWidth] = useState("");
  const [kitchenPackage, setKitchenPackage] = useState("Standard");
  const [totalEstimate, setTotalEstimate] = useState(null);
  const [breakdown, setBreakdown] = useState({}); // For detailed cost breakdown

  const calculateEstimate = () => {
    if (bedrooms <= 0 || tvWidth <= 0) {
      alert("Please enter valid positive values for bedrooms and TV width.");
      return;
    }

    // Bedroom Cost
    let bedroomCost = bedrooms * 75000;
    if (extraItems > 0) bedroomCost += 25000 * extraItems;

    // TV Unit Cost
    let tvUnitCost = tvWidth > 8 ? 200000 : 100000;

    // Kitchen Cost
    let kitchenCost = 200000;
    if (kitchenPackage === "Medium") kitchenCost = 400000; // Average of 3-5 Lakhs
    if (kitchenPackage === "Luxury") kitchenCost = 600000;

    // Total Estimate Calculation
    const total = bedroomCost + tvUnitCost + kitchenCost;

    // Update state with total and breakdown
    setTotalEstimate(total);
    setBreakdown({
      bedroomCost,
      tvUnitCost,
      kitchenCost,
    });
  };

  const resetForm = () => {
    setBedrooms("");
    setExtraItems("");
    setTvWidth("");
    setKitchenPackage("Standard");
    setTotalEstimate(null);
    setBreakdown({});
  };

  return (
    <div className="quotation-page px-6 py-8">
      <h1 className="text-3xl font-bold text-center mb-6">
        Get Your Quotation
      </h1>
      <div className="max-w-xl mx-auto bg-white p-6 rounded shadow-md">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            calculateEstimate();
          }}
          className="space-y-4"
        >
          {/* Bedrooms Section */}
          <div>
            <label
              htmlFor="bedrooms"
              className="block text-sm font-medium text-gray-700"
            >
              Number of Bedrooms
            </label>
            <input
              type="number"
              id="bedrooms"
              value={bedrooms}
              onChange={(e) => setBedrooms(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
              min="1"
              required
            />
          </div>

          {/* Extra Items Section */}
          <div>
            <label
              htmlFor="extraItems"
              className="block text-sm font-medium text-gray-700"
            >
              Extra Items per Room (Mirrors, Chairs, etc.)
            </label>
            <input
              type="number"
              id="extraItems"
              value={extraItems}
              onChange={(e) => setExtraItems(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
              min="0"
            />
          </div>

          {/* TV Unit Section */}
          <div>
            <label
              htmlFor="tvWidth"
              className="block text-sm font-medium text-gray-700"
            >
              TV Unit Width (in feet)
            </label>
            <input
              type="number"
              id="tvWidth"
              value={tvWidth}
              onChange={(e) => setTvWidth(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
              min="1"
              required
            />
          </div>

          {/* Kitchen Package Section */}
          <div>
            <label
              htmlFor="kitchenPackage"
              className="block text-sm font-medium text-gray-700"
            >
              Choose Kitchen Package
            </label>
            <select
              id="kitchenPackage"
              value={kitchenPackage}
              onChange={(e) => setKitchenPackage(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
            >
              <option>Standard</option>
              <option>Medium</option>
              <option>Luxury</option>
            </select>
          </div>

          <div className="flex space-x-4">
            <button
              type="submit"
              className="flex-1 py-3 bg-yellow-500 text-white rounded hover:bg-yellow-400 focus:outline-none"
            >
              Calculate
            </button>
            <button
              type="button"
              onClick={resetForm}
              className="flex-1 py-3 bg-gray-400 text-white rounded hover:bg-gray-500 focus:outline-none"
            >
              Reset
            </button>
          </div>
        </form>

        {totalEstimate !== null && (
          <div className="mt-6 bg-gray-100 p-4 rounded">
            <h2 className="text-xl font-bold">Estimated Cost</h2>
            <p className="text-lg">₹{totalEstimate.toLocaleString()}</p>
            <p className="text-sm text-gray-500">
              <strong>Breakdown:</strong>
              <ul>
                <li>Bedrooms: ₹{breakdown.bedroomCost.toLocaleString()}</li>
                <li>Extra Items: ₹{(extraItems * 25000).toLocaleString()}</li>
                <li>TV Unit: ₹{breakdown.tvUnitCost.toLocaleString()}</li>
                <li>Kitchen: ₹{breakdown.kitchenCost.toLocaleString()}</li>
              </ul>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Quotation;
